import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { APP_CONFIG, configurationsFactory } from './app/shared/configurations/configurations.factory';
import { environment } from './environments/environment';


configurationsFactory().then(async (config) => {

  if (environment.production) enableProdMode()

  try {
    return platformBrowserDynamic([{ provide: APP_CONFIG, useValue: config }])
      .bootstrapModule(AppModule);
  } catch (err) {
    return console.error(err);
  }
});

